<template>
    <v-row>
        <v-col cols="auto" align-self="center">
            <v-btn
            icon
            dark
            color="primary"
            @click="showEmailCredentialsModal(autoImportConfig)"
            >
            <v-icon dark>mdi-account-key-outline</v-icon>
            </v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="6" align-self="center">
            <v-select
            :items="autoImportConfig.folderList"
            v-model="autoImportConfig.rootFolder"
            :disabled="autoImportConfig.folderList.length == 0"
            :label="$t('RootFolder')"
            />
        </v-col>
        <v-col
            cols="1"
            sm="6"
            md="1"
            align-self="center"
            v-if="loading"
        >
            <v-progress-circular
            :size="20"
            :width="3"
            color="primary"
            indeterminate
            ></v-progress-circular>
        </v-col>
        <v-col
            cols="auto"
            align-self="center"
            v-if="!loading"
        >
            <v-btn
            icon
            dark
            color="primary"
            @click="getEmailFolders(autoImportConfig)"
            >
            <v-icon dark>mdi-refresh</v-icon>
            </v-btn>
        </v-col>

        <ContentTypeAutoImportConfigModalEmailLogin
            :ref="emailModalKey"
            @emailConfigurationSaved="saveEmailConfig"
        />
    </v-row>
</template>
<script>
import AutoImportService from '@/services/AutoImportService';
import ContentTypeAutoImportConfigModalEmailLogin from '@/components/administration/contentType/autoImport/ContentTypeAutoImportConfigEmailLogin';

export default {
    name: 'EmailProviderConfig',
    components: {
        ContentTypeAutoImportConfigModalEmailLogin
    },
    props: {
        validator: {
            type: Object,
            default: () => ({}),
        },
        item: {
            type: Object,
            default: () => ({}),
        }
    },
    created() {
        this.getEmailFolders(this.autoImportConfig);
    },
    data() {
        return {
            emailModalKey: 'emailModalKey',
            autoImportConfig: this.item,
            loading: false
        };
    },
    watch: {
        loading(newVal) {
            this.$emit('update-loading', newVal);
        }
    },
    methods: {
        showEmailCredentialsModal(autoImportConfig) {
            this.$refs[this.emailModalKey].show(autoImportConfig);
        },
        saveEmailConfig(loginEmailParametersModal) {
            this.autoImportConfig.emailAccount = loginEmailParametersModal.emailAccount;
            this.autoImportConfig.emailPassword = loginEmailParametersModal.emailPassword;
            this.autoImportConfig.emailServer = loginEmailParametersModal.emailServer;
            this.autoImportConfig.emailPort = loginEmailParametersModal.emailPort;
            this.autoImportConfig.emailUseSSL = loginEmailParametersModal.emailUseSSL;

            this.getEmailFolders(this.autoImportConfig);
            this.$emit('on-saved-config', this.autoImportConfig);
        },
        getEmailFolders(item) {
            this.loading = true;
            if (!item.emailAccount || !item.emailServer || !item.emailPort) {
                this.loading = false;
                return;
            }
            AutoImportService.getEmailFolders(item.toDto())
                .then((data) => {
                    item.folderList = data;
                    if (!item.rootFolder) {
                        if (item.folderList.some((x) => x == 'INBOX')) {
                            item.rootFolder = 'INBOX';
                        } else {
                            item.rootFolder = 'Inbox';
                        }
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    }

};
</script>